import React, { Component } from "react";
import { MuiThemeProvider, withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Responsive from "react-responsive";
import AppHeader from "../../AppHeader/AppHeader";
import AppTheme from "../../AppTheme";

import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SwipeableViews from "react-swipeable-views";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";

import adaugareIMG from "./assets/adaugare.png";
import programariIMG from "./assets/programari.png";

import Button from "@material-ui/core/Button";

import { Calendar, Views, momentLocalizer } from "react-big-calendar";
import moment from "moment";

import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import Grid from "@material-ui/core/Grid";

import {
  getManevre,
  getPatients,
  addEvent,
  getEventsByPatientIDAdmin,
  getEventsByDate,
  getEventsByVolunteerID,
  getVoluntarDetailsById,
  deleteEvent
} from "../../services/volunteer";

import styles from "./AddTimeSlotFormStyles";
import { existsTypeAnnotation } from "@babel/types";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const localizer = momentLocalizer(moment);

const Desktop = props => <Responsive {...props} minWidth={750} />;

const Mobile = props => <Responsive {...props} maxWidth={749} />;

const hours = [
  { id: 0, value: "08:00" },
  { id: 1, value: "08:30" },
  { id: 2, value: "09:00" },
  { id: 3, value: "09:30" },
  { id: 4, value: "10:00" },
  { id: 5, value: "10:30" },
  { id: 6, value: "11:00" },
  { id: 7, value: "11:30" },
  { id: 8, value: "12:00" },
  { id: 9, value: "13:00" },
  { id: 10, value: "13:30" },
  { id: 11, value: "14:00" },
  { id: 12, value: "14:30" },
  { id: 13, value: "15:00" },
  { id: 14, value: "15:30" },
  { id: 15, value: "16:00" },
  { id: 16, value: "17:30" },
  { id: 17, value: "18:00" },
  { id: 18, value: "18:30" },
  { id: 19, value: "19:00" },
  { id: 20, value: "19:30" },
  { id: 21, value: "20:00" }
];

function Event({ event }) {
  return (
    <span>
      <strong style={{ fontSize: 18 }}>{event.volunteer.name}</strong>
      {/*<p>{event.type ? event.type.name : ""}</p>*/}
      <p style={{ fontStyle: "italic" }}>{event.desc ? event.desc : ""}</p>
    </span>
  );
}

function EventAgenda({ event }) {
  return (
    <span>
      <p style={{ color: "#fff", fontWeight: 900, fontSize: 18 }}>
        {event.volunteer.name}
      </p>
      <p style={{ color: "#fff", fontWeight: 900, fontSize: 18 }}>
        {event.resourceId.name}
      </p>
      <p style={{ color: "#fff", fontWeight: 500, fontSize: 14 }}>
        {event.type.name}
      </p>
    </span>
  );
}

const customDayPropGetter = date => {
  if (moment(date).weekday() === 6 || moment(date).weekday() === 5)
    return {
      className: "special-day",
      style: {
        border: "solid 3px #faa"
      }
    };
  else return {};
};

const eventPropGetter = (event, start, end, isSelected) => {
  return {
    className: "event-type" + (event.type ? event.type.code : ""),
    style: {
      border: "solid 3px #faa"
    }
  };
};

class AddTimeSlotForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openConfirmDelete: false,
      volunteer: null,
      myEvents: null,
      manevre: [],
      patients: [],
      events: [],
      selectedPatient: -1,
      selectedManevre: -1,
      selectedStartDate: -1,
      selectedEndDate: -1,
      tabValue: 0,
      selectedDate: new Date(),
      disabledSave: true,
      hours: hours,
      comments: "",
      error: ""
    };
    this.validateForm = this.validateForm.bind(this);
  }

  async componentWillMount() {
    document.title = "Program Voluntariat - Creaza rezervare";
    const manevre = await getManevre();
    //console.log('manevre',manevre);
    const patients = await getPatients();
    const volunteer = await getVoluntarDetailsById(
      localStorage.getItem("volunteerId")
    );
    const values = await getEventsByDate(this.state.selectedDate);
    for (var i=0; i<patients.length;i++) {
      var count = 0
      for (var j=0; j<values.length; j++) {
        if (patients[i]._id===values[j].resourceId._id)
        {
          count =count + 1;
        }
        
      }
      patients[i].dayCnt = count;
    }
    //console.log(patients);
    this.setState({
      manevre,
      patients,
      volunteer
    });
   

    await this.getMyEvents(localStorage.getItem("volunteerId"));
    this.validateForm();
  }

  componentDidUpdate() {
    setTimeout(function() {
      if (this.swipeableViewsRef) {
        this.swipeableViewsRef.current
          .getChildContext()
          .swipeableViews.slideUpdateHeight();
      }
    }, 3000);
  }

  async getEvents(value) {
    if (value === -1) return;
    const events = await getEventsByPatientIDAdmin(value);
    this.setState({ events });
  }

  async getMyEvents(id) {
    const myEvents = await getEventsByVolunteerID(id);
    this.setState({ myEvents });
  }

  dateCompare(event) {
    if (
      this.getSelectedDate(1) > moment(event.start) &&
      this.getSelectedDate(2) > moment(event.end)
    )
      return true;
    if (
      this.getSelectedDate(1) < moment(event.start) &&
      this.getSelectedDate(2) < moment(event.end)
    )
      return true;
    return false;
  }

  handleSelect = ({ start, end }) => {
    const title = window.prompt("New Event name");
    if (title)
      this.setState({
        events: [
          ...this.state.events,
          {
            start,
            end,
            title
          }
        ]
      });
  };
  handleChange = async event => {
    this.setState(oldValues => ({
      ...oldValues,
      [event.target.name]: event.target.value
    }));

    if (event.target.name === "selectedPatient") {
      await this.getEvents(event.target.value);
    }

    if (event.target.name === "selectedStartDate") {
      if (event.target.value === hours.length - 1) {
        this.setState(oldValues => ({
          ...oldValues,
          selectedEndDate: event.target.value
        }));
      }
      if (event.target.value > this.state.selectedEndDate) {
        this.setState(oldValues => ({
          ...oldValues,
          selectedEndDate: event.target.value + 1
        }));
      }
    }
    if (event.target.name === "selectedEndDate") {
      if (event.target.value < this.state.selectedStartDate) {
        this.setState(oldValues => ({
          ...oldValues,
          selectedStartDate: event.target.value - 1
        }));
      }
    }
    await this.validateForm(event.target.name, event.target.value);
  };
  handleDateChange = async date => {
    this.setState({ selectedDate: date.toDate() });
    const values = await getEventsByDate(date.toDate());
    const patients = this.state.patients;
    for (var i=0; i<patients.length;i++) {
      var count = 0
      for (var j=0; j<values.length; j++) {

        if (patients[i]._id===values[j].resourceId._id)
        {
          count =count + 1;
        }
        
      }
      patients[i].dayCnt = count;
    }
    //console.log(patients);
    this.setState(oldValues => ({
      ...oldValues,
      patients: patients
    }));
    this.validateForm();
  };
  handleChangeComments = event => {
    this.setState({ comments: event.target.value });
    this.validateForm();
  };

  handleClickOpen = id => {
    this.setState({ selectedEvent: id, openConfirmDelete: true });
  };

  handleDelete = async () => {
    await deleteEvent(this.state.selectedEvent);
    this.setState({ selectedEvent: null, openConfirmDelete: false });
    await this.getMyEvents(this.state.volunteer[0]._id);
  };
  handleCloseDelete = () => {
    this.setState({ selectedEvent: null, openConfirmDelete: false });
  };

  getSelectedDate(type) {
    if (type === 1) {
      return new moment(
        new moment(this.state.selectedDate).format("DD/MM/YYYY") +
          " " +
          hours[this.state.selectedStartDate].value,
        "DD/MM/YYYY HH:mm"
      ).toDate();
    } else
      return new moment(
        new moment(this.state.selectedDate).format("DD/MM/YYYY") +
          " " +
          hours[this.state.selectedEndDate].value,
        "DD/MM/YYYY HH:mm"
      ).toDate();
  }

  validateForm = async (control, value) => {
    if (this.state.selectedPatient === -1) {
      if (!(control === "selectedPatient" && value)) {
        this.setState({
          error: "Nu ati selectat un pacient.",
          disabledSave: true
        });
      }
      return;
    }

    /*  if (this.state.selectedManevre === -1) {
      if (!(control === "selectedManevre" && value)) {
        this.setState({
          error: "Nu ati specificat manevra.",
          disabledSave: true
        });
        return;
      }
    }*/

    if (this.state.selectedStartDate === -1) {
      if (!(control === "selectedStartDate" && value)) {
        this.setState({
          error: "Nu ati specificat ora de start.",
          disabledSave: true
        });
        return;
      }
    }
    if (this.state.selectedEndDate === -1) {
      if (!(control === "selectedEndDate" && value)) {
        this.setState({
          error: "Nu ati specificat ora de sfarsit.",
          disabledSave: true
        });
        return;
      }
    }

    for (var i = 0; i < this.state.events.length; i++) {
      if (!this.dateCompare(this.state.events[i])) {
        this.setState({
          error:
            "Exista deja o programare in aceeasi perioada de timp selectata.",
          disabledSave: true
        });
        return;
      }
    }
    this.setState({ error: "", disabledSave: false });
  };
  cleanSession() {
    this.setState({
      events: [],
      selectedPatient: -1,
      selectedManevre: -1,
      selectedStartDate: -1,
      selectedEndDate: -1,
      tabValue: 0,
      selectedDate: new Date(),
      disabledSave: true,
      hours: hours,
      comments: "",
      error: ""
    });
  }
  getUser = () => {
    return this.state.volunteer[0]._id;
  };
  saveEvent = async () => {
    var newEvent = {};
    newEvent.volunteer = this.getUser();
    newEvent.title = "Programare";
    newEvent.start = this.getSelectedDate(1);
    newEvent.end = this.getSelectedDate(2);
    newEvent.type = (this.state.manevre && this.state.manevre.length>0) ? this.state.manevre[0]._id : '0';
    newEvent.resourceId = this.state.selectedPatient;
    newEvent.desc = this.state.comments;
    await addEvent(newEvent);
    await this.getMyEvents(this.state.volunteer[0]._id);
    this.cleanSession();
  };

  render() {
    const { classes } = this.props;
    const { viewModel } = this.state;
    return (
      <MuiThemeProvider theme={AppTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <div className={classes.volunteerForm}>
            <AppHeader className={classes.appHeader} />

            <Paper className={classes.formContainer}>
              <h1 className={classes.formTitle}>
                Salut{" "}
                {this.state.volunteer &&
                  this.state.volunteer[0] &&
                  this.state.volunteer[0].name}
              </h1>
              <Tabs
                value={this.state.tabValue}
                style={{ width: "100%" }}
                onChange={(event, newValue) => {
                  if (newValue == 3) {
                    localStorage.clear();
                    this.props.history.push("/voluntar");
                  } else {
                    this.setState({ tabValue: newValue });
                  }
                }}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                aria-label="full width tabs example"
              >
                <Tab label="Calendar" />
                <Tab label="Adauga" />
                <Tab label="Info" />
                <Tab label="Iesire" />
              </Tabs>
              <SwipeableViews
                axis={"x"}
                style={{ maxWidth: "calc(100%)" }}
                index={this.state.tabValue}
                animateHeight={false}
                ref={this.swipeableViewsRef}
                onChangeIndex={index => {
                  this.setState({ tabValue: index });
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column"
                  }}
                >
                  <h3 className={classes.formTitle}>Programarile Mele</h3>
                  <div className={classes.root}>
                    {this.state.myEvents &&
                      this.state.myEvents.length === 0 && (
                        <h3>
                          Nu aveti programari efecutate in sistem in perioada
                          urmatoare!
                        </h3>
                      )}
                    <div
                      style={{
                        flex: 1,
                        flexDirection: "column",
                        width: "100%"
                      }}
                    >
                      {this.state.myEvents &&
                        this.state.myEvents.map((event, i) => {
                          return (
                            <Card
                              key={i}
                              style={{
                                margin: 5,
                                display: "flex",
                                flexDirection: "row",
                                justifyItems: "space-between",
                                alignItems: "space-between"
                              }}
                            >
                              <CardContent
                                style={{ flex: 1 }}
                                className={
                                  "event-type" +
                                  (event.type ? event.type.code : "")
                                }
                              >
                                <p>
                                  {moment(event.start).format(
                                    "ddd, DD MMM HH:mm"
                                  ) +
                                    "-" +
                                    moment(event.end).format("HH:mm")}
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: 18,
                                    lineHeight: 1.6
                                  }}
                                >
                                  {event.resourceId.name}
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: 14,
                                    lineheight: 1.5
                                  }}
                                >
                                  {event.desc}
                                </p>
                              </CardContent>
                              <CardActions style={{ backgroundColor: "#f77" }}>
                                <Button
                                  size="small"
                                  color="default"
                                  onClick={() => {
                                    this.handleClickOpen(event._id);
                                  }}
                                >
                                  Sterge
                                </Button>
                              </CardActions>
                            </Card>
                          );
                        })}
                      <Dialog
                        open={this.state.openConfirmDelete}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                      >
                        <DialogTitle id="alert-dialog-slide-title">
                          Stergere programare
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText id="alert-dialog-slide-description">
                            Sunteti siguri ca vreti sa stergeti programarea?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={this.handleCloseDelete}
                            color="primary"
                          >
                            Renunta
                          </Button>
                          <Button
                            onClick={this.handleDelete}
                            color="default"
                            style={{ backgroundColor: "#f77" }}
                          >
                            Da
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column"
                  }}
                >
                  <h3 className={classes.formTitle}>Adauga Programare</h3>

                  <div className={classes.root}>
                    <div>
                      <p
                        style={{
                          margin: "20px 0",
                          fontWeight: "bold"
                        }}
                      >
                        {" "}
                        Va rugam sa faceti programari cu prioritate pentru cei
                        pentru care nu exista programari in ziua respectiva. Va multumim!
                      </p>
                      <p>In data de <b> {moment(this.state.selectedDate).format("DD.MM.YYYY")}</b> au fost facute urmatoarele programari:</p>
                      <ul>
                      {this.state.patients &&
                        this.state.patients.map((patient, i) => {
                          return (
                            <li key={i} >
                              <b>{patient.name}</b> - <span style={{color:patient.dayCnt===0?"#f00":"inherit" }}>{patient.dayCnt}</span> programari
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                    <form className={classes.rootForm} autoComplete="off">
                      <Grid container spacing={4}>
                        <Grid item md={12} lg={12} sm={12} xs={12}>
                          <FormControl
                            className={classes.formControl}
                            fullWidth={true}
                            error={false}
                          >
                            <InputLabel htmlFor="selectedPatient-error">
                              Pacient
                            </InputLabel>
                            <Select
                              value={this.state.selectedPatient}
                              onChange={this.handleChange}
                              name="selectedPatient"
                              inputProps={{
                                id: "selectedPatient-error"
                              }}
                            >
                              <MenuItem value="-1">
                                <em>Selectati un pacient</em>
                              </MenuItem>
                              {this.state.patients &&
                                this.state.patients.map((patient, i) => {
                                  return (
                                    <MenuItem key={i} value={patient._id}>
                                      {patient.name}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                            {false && <FormHelperText>Error</FormHelperText>}
                          </FormControl>
                        </Grid>
                        {/* <Grid item md={6} lg={6} sm={12} xs={12}>
                          <FormControl
                            className={classes.formControl}
                            fullWidth={true}
                            error={false}
                          >
                            <InputLabel htmlFor="selectedManevre-error">
                              Tip manevra
                            </InputLabel>
                            <Select
                              value={this.state.selectedManevre}
                              onChange={this.handleChange}
                              name="selectedManevre"
                              inputProps={{
                                id: "selectedManevre-error"
                              }}
                            >
                              <MenuItem value="-1">
                                <em>Selectati manevra</em>
                              </MenuItem>
                              {this.state.manevre.map((manevra, i) => {
                                return (
                                  <MenuItem key={i} value={manevra._id}>
                                    {manevra.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            {false && <FormHelperText>Error</FormHelperText>}
                          </FormControl>
                            </Grid>*/}
                        <Grid item md={4} lg={4} sm={12} xs={12}>
                          <FormControl
                            className={classes.formControl}
                            fullWidth={true}
                            error={false}
                          >
                            <KeyboardDatePicker
                              id="date-picker-dialog"
                              label="Data programare"
                              format="DD/MM/YYYY"
                              value={this.state.selectedDate}
                              onChange={this.handleDateChange}
                              minDate={new Date()}
                              KeyboardButtonProps={{
                                "aria-label": "schimba data"
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item md={4} lg={4} sm={12} xs={12}>
                          <FormControl
                            className={classes.formControl}
                            fullWidth={true}
                            error={false}
                          >
                            <InputLabel htmlFor="selectedStartDate-error">
                              Ora Inceput
                            </InputLabel>

                            <Select
                              value={this.state.selectedStartDate}
                              onChange={this.handleChange}
                              name="selectedStartDate"
                              inputProps={{
                                id: "selectedStartDate-error"
                              }}
                            >
                              <MenuItem value="-1">
                                <em>Selectati </em>
                              </MenuItem>
                              {hours.map((hour, i) => {
                                return (
                                  <MenuItem key={i} value={hour.id}>
                                    {hour.value}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            {false && <FormHelperText>Error</FormHelperText>}
                          </FormControl>
                        </Grid>
                        <Grid item md={4} lg={4} sm={12} xs={12}>
                          <FormControl
                            className={classes.formControl}
                            fullWidth={true}
                            error={false}
                          >
                            <InputLabel htmlFor="selectedEndDate-error">
                              Ora Sfarsit
                            </InputLabel>
                            <Select
                              value={this.state.selectedEndDate}
                              onChange={this.handleChange}
                              fullWidth
                              name="selectedEndDate"
                              inputProps={{
                                id: "selectedEndDate-error"
                              }}
                            >
                              <MenuItem value="-1">
                                <em>Selectati </em>
                              </MenuItem>
                              {hours.map((hour, i) => {
                                return (
                                  i > 0 && (
                                    <MenuItem key={i} value={hour.id}>
                                      {hour.value}
                                    </MenuItem>
                                  )
                                );
                              })}
                            </Select>
                            {false && <FormHelperText>Error</FormHelperText>}
                          </FormControl>
                        </Grid>
                        <Grid item md={12} lg={12} sm={12} xs={12}>
                          <FormControl
                            className={classes.formControl}
                            fullWidth={true}
                            error={false}
                          >
                            <TextField
                              label="Comentarii"
                              name="comments"
                              multiline
                              rowsMax="4"
                              value={this.state.comments}
                              onChange={this.handleChangeComments}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <p
                            style={{
                              color: "#f00",
                              fontWeight: 500,
                              fontStyle: "italic"
                            }}
                          >
                            {this.state.error}
                          </p>
                        </Grid>
                        <Grid item xs={12}>
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={this.state.disabledSave}
                            className={classes.button}
                            onClick={this.saveEvent}
                          >
                            Salveaza Programare
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  </div>

                  <Desktop>
                    <Calendar
                      localizer={localizer}
                      culture={"ro"}
                      drilldownView="agenda"
                      className={classes.calendar}
                      events={this.state.events}
                      defaultView={Views.DAY}
                      min={moment("8:00am", "h:mma").toDate()}
                      max={moment("8:00pm", "h:mma").toDate()}
                      views={["day"]}
                      step={60}
                      timeslots={1}
                      popup={true}
                      onSelectSlot={this.handleSelect}
                      showMultiDayTimes={true}
                      eventPropGetter={eventPropGetter}
                      date={this.state.selectedDate}
                      onNavigate={date => {
                        this.setState({ selectedDate: date });
                      }}
                      components={{
                        event: Event,
                        agenda: {
                          event: EventAgenda
                        }
                      }}
                      messages={{
                        date: "Data",
                        time: "Ora",
                        event: "Eveniment",
                        allDay: "Toata ziua",
                        week: "Saptamana",
                        work_week: "Saptamana lucratoare",
                        day: "Zi",
                        month: "Luna",
                        previous: "<--",
                        next: "-->",
                        yesterday: "Ieri",
                        tomorrow: "Maine",
                        today: "Astazi",
                        agenda: "Agenda",
                        noEventsInRange:
                          "Nu sunt inregistrari in aceasta perioada!"
                      }}
                    />
                  </Desktop>

                  <Mobile>
                    <Calendar
                      localizer={localizer}
                      culture={"ro"}
                      drilldownView="agenda"
                      className={classes.calendar}
                      events={this.state.events}
                      defaultView={Views.DAY}
                      min={moment("8:00am", "h:mma").toDate()}
                      max={moment("8:00pm", "h:mma").toDate()}
                      views={["day"]}
                      step={60}
                      timeslots={1}
                      popup={true}
                      date={this.state.selectedDate}
                      onNavigate={date => {
                        this.setState({ selectedDate: date });
                      }}
                      onSelectSlot={this.handleSelect}
                      dayPropGetter={customDayPropGetter}
                      showMultiDayTimes={false}
                      eventPropGetter={eventPropGetter}
                      components={{
                        event: Event
                      }}
                      messages={{
                        date: "Date",
                        time: "Time",
                        event: "Event",
                        allDay: "All Day",
                        week: "Saptamana",
                        work_week: "Saptamana lucratoare",
                        day: "Zi",
                        month: "Month",
                        previous: "<--",
                        next: "-->",
                        yesterday: "Ieri",
                        tomorrow: "Maine",
                        today: "Astazi",
                        agenda: "Agenda",
                        noEventsInRange:
                          "Nu sunt inregistrari in aceasta perioada!"
                      }}
                    />
                  </Mobile>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column"
                  }}
                >
                  <h3 className={classes.formTitle}>Informatii</h3>
                  <div className={classes.root}>
                    <div
                      style={{
                        flex: 1,
                        flexDirection: "column",
                        width: "100%"
                      }}
                    >
                      <h4>Adaugare programare</h4>
                      <img
                        src={adaugareIMG}
                        style={{ width: "100%", height: "auto", opacity: 0.5 }}
                        alt="adaugare programare"
                      />
                      <p>
                        Adaugarea unei programari se face dupa urmatorii pasi:
                      </p>
                      <ol>
                        <li>
                          {" "}
                          Selectati pacientul din campul de selectie "Pacient"
                        </li>
                        <li>
                          {" "}
                          Odata cu selectia pacientului in partea de jos a
                          formului se pot vedea rezervarile realizate in ziua
                          curenta
                        </li>
                        <li>
                          {" "}
                          Selectati manevra pentru care doriti programarea din
                          campul de selectie "Tip manevra"
                        </li>
                        <li>
                          {" "}
                          Selectati ziua in care doriti programarea din campul
                          "Data programare".
                        </li>
                        <li>
                          {" "}
                          Selectati un interval orar pentru care doriti
                          programarea folosind "Ora Inceput" si "Ora sfarsit"
                          intre 8AM si 8PM.
                        </li>
                        <li>
                          {" "}
                          Nu puteti selecta pentru acelasi pacient un interval
                          orar care se suprapune cu alta programare a altui
                          voluntar pentru acelasi pacient.
                        </li>
                        <li>
                          {" "}
                          Daca nu sunt indicate erori de selectie butonul
                          "Salveaza programare" se va activa si il puteti apasa
                          pentru finalizarea programarii.
                        </li>
                        <li>
                          {" "}
                          Programarea va aparea in sectiunea dvs "Calendarul
                          meu"
                        </li>
                      </ol>
                      <br />
                      <br />
                      <h4>Calendarul meu</h4>
                      <img
                        src={programariIMG}
                        style={{ width: "100%", height: "auto", opacity: 0.5 }}
                        alt="adaugare programare"
                      />
                      <p>
                        In sectiunea "Calendarul Meu" apar toate programarile
                        dvs realizate la care urmeaza sa participati.
                      </p>
                      <p>
                        Daca nu mai puteti ajunge la una din programari,
                        utilizati butonul sterge si confirmati mesajul de
                        stergere a programarii pentru a elibera calendarul si da
                        posibilitatea unui alt voluntar sa programeze.
                      </p>

                      <h4>Va multumim!</h4>
                    </div>
                  </div>
                </div>
              </SwipeableViews>
            </Paper>
          </div>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(AddTimeSlotForm);
